<ng-container *ngIf="groups?.length; then allocationsTemplate; else emptyTemplate"></ng-container>


<ng-template #allocationsTemplate>


    <div class="groups">

        <div class="group" *ngFor="let group of groups">

            <div class="group-actions">
                <div class="left">
                    {{$safeNavigationMigration(group?.date) | dateTimeFormat:timezone:'EEEE - dd/MM/yyyy'}}
                </div>
            </div>

            <div class="allocation" *ngFor="let allocation of group?.allocations">

                <div class="allocation-detail" *ngIf="allocation">

                    <div class="allocation-detail-container">
                        <div appointmentStatusColor [status]="allocation.status" [renderStatusName]="false" class="booking-status" [ngClass]="{'show-dashed': allocation.bookingStatus == BookingStatus.Tentative}"> </div>

                        <div class="display">

                            <div class="info">
                                <div class="highlight">
                                    <div *ngIf="isShadow(allocation)"><i class="fa fa-truck"></i></div>
                                    <div class="time">
                                        <span>{{allocation.startDate | timeSimple:timezone:timeFormat}}</span>
                                        <i class="fa fa-long-arrow-right"></i>
                                        <span>{{allocation.endDate | timeSimple:timezone:timeFormat}}</span>
                                    </div>

                                    <div class="actions">
                                        <w-tag appointmentStatusColor color="white" borderColor="transparent" [status]="allocation.status" [renderStatusName]="false" *ngIf="allocation.status" [label]="allocation.status" />

                                        @if(allocation?.isConflict){
                                            <i class="fa-regular fa-calendar-circle-exclamation" style="color: var(--colors-background-danger)"></i>
                                        }
                                        <w-button *ngIf="canEdit(allocation)" displayStyle="Tertiary" iconLeft="fa fa-edit" (onClick)="onEdit(allocation)" />
                                        <w-button *ngIf="canDelete(allocation)" iconLeftColor="red" displayStyle="Tertiary" iconLeft="fa fa-trash" (onClick)="onDelete(allocation)" />
                                    </div>
                                </div>

                                <ng-container *ngIf="source === Source.ContractorPortal; else tenant">
                                    <div class="resource">
                                        <multiple-users *ngIf="!(allocation.contractorResource | unAllocated)" [users]="[allocation.contractorResource]" [limit]="1" [size]="20" />
                                        <span>{{allocation.contractorResource?.name}}</span>
                                    </div>
                                </ng-container>

                                <ng-template #tenant>
                                    <div class="resource">
                                        <multiple-users *ngIf="!(allocation.resource | unAllocated)" [users]="[allocation.resource]" [limit]="1" [size]="20" />
                                        <span>{{allocation.resource?.name}}</span>
                                    </div>
                                </ng-template>

                                <div class="note text-bold" *ngIf="allocation.name" title="{{allocation.name}}">{{allocation.name}}</div>
                                <div class="note" *ngIf="allocation.note" title="{{allocation.note}}">{{allocation.note}}</div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>
        </div>

    </div>


</ng-template>


<ng-template #emptyTemplate>
    <empty-message message="No Appointments Found." icon=""></empty-message>
</ng-template>